import { AlertTriangle, Plus, ShieldCheck, Trash2 } from "lucide-react";
import BFCiPhoto from "./BFCiPhoto";

const GF = [["nume", "Nume și prenume *"], ["domiciliu", "Domiciliu *"], ["ci_serie", "CI serie *"], ["ci_nr", "CI număr *"], ["cnp", "CNP *"],
  ["telefon", "Telefon *"], ["email", "E-mail *"], ["parti", "% părți sociale"]];
const LBL = Object.fromEntries(GF.map(([k, l]) => [k, l.replace(" *", "")]));
const WIDE = { nume: "is-wide2", domiciliu: "is-wide", cnp: "is-wide2", email: "is-wide2" };
const blank = (admin = false, nume = "") => ({ nume, domiciliu: "", ci_serie: "", ci_nr: "", cnp: "", telefon: "", email: "", parti: "", admin, ci_doc: "", ci_doc2: "" });
const keep = (g, f) => Object.fromEntries(Object.entries(f).filter(([k, v]) => v && !(g.admin && k === "nume")));

export default function BFGuarantors({ reader, admin, fid, onChange, onCi, errors = [] }) {
  const has = fid.some((g) => g.admin);
  const set = (i, k, v) => onChange(fid.map((g, j) => (j === i ? { ...g, [k]: v } : g)));
  const fill = (i, f, doc, slot) => { onChange(fid.map((g, j) => (j === i ? { ...g, ...keep(g, slot === "ci_doc2" ? { domiciliu: f.domiciliu, cnp: f.cnp } : f), [slot]: doc } : g))); onCi?.(); };
  const toggle = () => onChange(has ? fid.filter((g) => !g.admin) : [blank(true, admin), ...fid]);
  return (
    <div className="bf-fid" data-testid="bf-fid">
      <h4><ShieldCheck size={16} /> Fidejusiune (garanția personală)</h4>
      <p className="st-hint">Intră în același contract, la final. Fără fidejusiune semnată la toate 3 firmele, clientul cumpără doar cu cash sau ordin de plată, plătit înainte de livrare. La buletinele noi (fără domiciliu) fotografiază și foaia cu datele: verificăm că ce ai scris se potrivește cu pozele.</p>
      <label className="bf-lead-consent"><input type="checkbox" checked={has} onChange={toggle} data-testid="bf-fid-admin" /><span>Administratorul ({admin || "—"}) este fidejusor</span></label>
      {fid.map((g, i) => {
        const err = errors.find((e) => e.index === i)?.errors || {};
        return (
          <div key={i} className="bf-fid-card" data-testid={`bf-fid-${i}`}>
            <div className="bf-sign-head"><b>{g.admin ? `Administrator · ${admin}` : `Asociat ${i + (has ? 0 : 1)}`}</b>
              {!g.admin && <button type="button" className="st-btn st-btn--ghost" onClick={() => onChange(fid.filter((_, j) => j !== i))} aria-label="Șterge" data-testid={`bf-fid-del-${i}`}><Trash2 size={14} /></button>}</div>
            {Object.keys(err).length > 0 && (
              <ul className="bf-ci-err" data-testid={`bf-fid-${i}-mismatch`}>
                {Object.entries(err).map(([k, v]) => <li key={k}><AlertTriangle size={13} /> {k === "foaie" ? v : <>{LBL[k] || k}: în poză scrie <b>{v}</b></>}</li>)}
              </ul>
            )}
            <div className="bfc-grid">
              {GF.filter(([k]) => !(g.admin && k === "nume")).map(([k, l]) => (
                <label key={k} className={`bfc-f ${WIDE[k] || ""} ${err[k] ? "is-bad" : ""}`}><span className="st-label">{l}</span>
                  <input value={g[k] || ""} inputMode={k === "cnp" || k === "parti" ? "numeric" : k === "telefon" ? "tel" : k === "email" ? "email" : undefined} maxLength={k === "cnp" ? 13 : undefined} onChange={(e) => set(i, k, e.target.value)} data-testid={`bf-fid-${i}-${k}`} /></label>
              ))}
            </div>
            <div className="share-actions">
              <BFCiPhoto reader={reader} done={!!g.ci_doc} onRead={(f, doc) => fill(i, f, doc, "ci_doc")} testid={`bf-fid-${i}-ci`} />
              <BFCiPhoto reader={reader} part="foaie" done={!!g.ci_doc2} onRead={(f, doc) => fill(i, f, doc, "ci_doc2")} testid={`bf-fid-${i}-ci2`} />
            </div>
          </div>
        );
      })}
      {fid.length < 6 && <button type="button" className="st-btn st-btn--ghost" onClick={() => onChange([...fid, blank()])} data-testid="bf-fid-add"><Plus size={14} /> Adaugă asociat fidejusor</button>}
    </div>
  );
}
